<template>
    <v-container fluid style="padding: 30px 40px">
        <v-layout>
            <div style="text-align: left" v-show="generatingPDF">
                <h3 class="med-text blue-text" style="font-size:15pt">Please wait, generating report..</h3>
            </div>
            <v-btn
                    color="primary"
                    text
                    @click="closeDialog"
                    style="position: absolute; right: 5px; top: 10px"
                    v-show="!generatingPDF"
            >
                <v-icon
                        right
                        style="color: gray"
                >mdi-close
                </v-icon>
            </v-btn>
            <v-flex v-show="!generatingPDF">
                <div style="text-align: left">
                    <h3 class="med-text blue-text" style="font-size:15pt">To whom should this report be addressed
                        to?</h3>
                </div>
                <v-textarea
                        outlined
                        label="Address"
                        :placeholder="placeholder"
                        v-model="address"
                        ref="addressArea"
                        :rules="rules"
                        hint="Please enter the address in 6 lines max."
                        rows="7"
                        style="margin-top: 20px"
                ></v-textarea>
                <div style="display: flex; justify-content: space-between">
                    <highlight-button @click.native="skip">
                        <v-icon>mdi-debug-step-over</v-icon>
                        Skip
                    </highlight-button>
                    <highlight-button @click.native="generate" color="green">
                        <v-icon>mdi-check</v-icon>
                        Submit
                    </highlight-button>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import HighlightButton from "../../../components/HighlightButton";
    import exportPDF from '@/utils/generateCertReport';

    export default {
        name: "AddressRequest",
        components: {HighlightButton},
        data: function () {
            return {
                address: "",
                generatingPDF: false,
                placeholder: "Example:\nWES, 434151,\n" +
                    "World Education Services,\n" +
                    "Attention: Documentation Center\n" +
                    "2 Carlton Street Suite 1400\n" +
                    "Toronto, ON M5B 1J3\n" +
                    "CANADA",
                rules: [
                    v => this.getNumLines(v) <= 6 || "Max. 6 lines are allowed"
                ]
            }
        },
        computed: {
            files() {
                return this.$store.state.verifier.files;
            }
        },
        methods: {
            getNumLines(v) {
                return v && v.trim().length ? v.trim().split(/\r\n|\r|\n/).length : 0
            },
            closeDialog() {
                this.$refs.addressArea.reset();
                this.$root.$emit('close-report-dialog');
            },
            skip() {
                this.$root.$emit('generated-report');
              console.log(this.files[0], this.files[0]._file)
                exportPDF("", {certPdf: this.files[0]._file});
            },
            async generate() {
                if(!this.$refs.addressArea.validate()) {
                    return;
                }
                this.$store.dispatch('verifier/statReport', this.files[0]);
                const address = this.address ? this.address.trim() : "";
                this.generatingPDF = true;
                this.$refs.addressArea.reset();
                this.$root.$emit('generated-report');
                await exportPDF(address, {certPdf: this.files[0]._file});
                this.generatingPDF = false;
            }
        }
    }
</script>

<style scoped>

</style>
